import React from 'react';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { StyledElement } from './styles.js';

function Item({
  title,
  path,
  icon,
  isActive,
  isLogout,
  action,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
  isCollapsed,
}) {
  const handleClick = () => {
    if (!isActive) return; // Não executa se estiver desabilitado
    action(path);
    onClick();
  };

  const renderTooltip = (text) => (props) =>
    (
      <Tooltip id='button-tooltip' {...props}>
        {text}
      </Tooltip>
    );

  return (
    <StyledElement
      isActive={isActive}
      isLogout={isLogout}
      isHovered={isHovered}
      isCollapsed={isCollapsed}
    >
      {!isActive ? (
        // Renderiza como texto quando desabilitado
        <div className="disabled-item">
          {icon}
          {!isCollapsed && <span>{title}</span>}
        </div>
      ) : (
        // Renderiza como botão quando ativo
        <OverlayTrigger placement='right' overlay={renderTooltip(title)}>
          <button
            id='navigation-item'
            type='button'
            onClick={handleClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            disabled={!isActive && !isLogout}
          >
            {icon}
            {!isCollapsed && <span>{title}</span>}
          </button>
        </OverlayTrigger>
      )}
    </StyledElement>
  );
}

export default Item;
